module.exports = "/assets/data/f39685be20da5d9f20825a4aae5355af-CA6.data.json";